import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PillComponent } from '../components/pill/pill.component';
import { RiskPillComponent } from '../components/risk-pill/risk-pill.component';
import { TaskReviewStatusComponent } from '../components/task-risk-status/task-review-status.component';
import { TaskReviewStatus } from '../../../enums/supplier-risk-management/task-review-status';
import { ISupplierTask } from '../../../interfaces/supplier-risk-management/supplier-risk-management';
import { VmePipesModule } from '../../../vme-pipes.module';
import { ReviewStatusChange } from '../../../interfaces/supplier-risk-management/review-status-change';

@Component({
  selector: 'risk-management-supplier-list-item-task',
  standalone: true,
  imports: [
    CommonModule,
    PillComponent,
    RiskPillComponent,
    TaskReviewStatusComponent,
    VmePipesModule,
  ],
  templateUrl: './risk-management-supplier-list-item-task.component.html',
  styleUrls: ['./risk-management-supplier-list-item-task.component.css'],
})
export class RiskManagementSupplierListItemTaskComponent implements OnInit {
  @Input() supplierTask: ISupplierTask;
  @Output() reviewStatusChange = new EventEmitter<ReviewStatusChange>();

  constructor() {}

  ngOnInit(): void {}

  protected handleRiskStatusChange(reviewStatus: TaskReviewStatus, taskId: number): void {
    this.reviewStatusChange.emit({ taskId, reviewStatus });
  }

  protected readonly TaskRiskStatusEnum = TaskReviewStatus;
}
